/**
 * Created by joerg on 20.05.17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Utils from '../utils/Utils';
import InputComponent from '../components/InputComponent';
import OutPutComponent from '../components/OutPutComponent';
import InputModel from '../models/InputModel'
import DropDown from '../components/DropDown'
import ErrorTexts from './ErrorTexts';



@observer
export default class BaseDataEntry extends React.Component {

    _onChange(e,entry){
        console.log('ch',e.target.value,entry)
        entry.value = e.target.value;
    }
    componentDidUpdate(){
        setTimeout(()=>{requestAnimationFrame(this._calcwidths);},200);

    }
    componentDidMount(){
        this.componentDidUpdate();
    }
    _calcwidths(){
        console.log('calcwidth')

        Utils.normalizeAddonWidths('#basedataentry')



    }

    render (){
        const {baseDataStore,brespaDataStore} = this.props;
      //  const self = this;
        //console.log("entfcomp",baseDataStore.entfernungcomp.value)
        var z = 200;
        return <div id="basedataentry" className="well">
            <h4>Kostenvergleich zwischen BRESPA®-Decken, Halbfertigteildecken und Ortbetondecken<br/>Basisdaten</h4>
            <hr/>
            <div className='row'>
                <div className='col-md-4'>
                    {baseDataStore.entries.map(entry => {
                            z--;
                            var styles = {zIndex : z};
                            if (entry instanceof InputModel) {
                                return( <div className="form-group zup" key={entry.key} style={styles}>

                                    <InputComponent inputModel={entry} inputClasses={['size-input-height']}/>
                                </div>)
                            }else{
                                return (<div key={entry.key} className="form-group zup" style={styles}>
                                    <div className="input-group size-input-height" style={{width:'100%'}} >
                                        <div className="input-group-addon left-addon-dd" dangerouslySetInnerHTML={{__html: entry.title}}></div>
                                        <div className="input-group-btn ">
                                            <DropDown key={entry.key} dataProvider={entry} onSelect={entry.onSelect}/>
                                        </div>
                                    </div>
                                </div>)
                            }

                        }
                    ) }
                    <div className="form-group zup" key={baseDataStore.entfernung.key} style={{zIndex : z-1}}>

                        <InputComponent inputModel={baseDataStore.entfernung} inputClasses={['size-input-height']}/>
                    </div>
                    {baseDataStore.entries2.map(entry => {
                            z--;
                            var styles = {zIndex : z};
                            if (entry instanceof InputModel) {
                                return( <div className="form-group zup" key={entry.key} style={styles}>

                                    <InputComponent inputModel={entry} inputClasses={['size-input-height']}/>
                                </div>)
                            }else{
                                return (<div key={entry.key} className="form-group zup" style={styles}>
                                    <div className="input-group size-input-height" style={{width:'100%'}} >
                                        <div className="input-group-addon left-addon-dd" dangerouslySetInnerHTML={{__html: entry.title}}></div>
                                        <div className="input-group-btn ">
                                            <DropDown key={entry.key} dataProvider={entry} onSelect={entry.onSelect}/>
                                        </div>
                                    </div>
                                </div>)
                            }

                        }
                    ) }
                    <div className="form-group zup" >
                        <OutPutComponent outputModel={baseDataStore.deckenflaeche} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
                    </div>
                    <ErrorTexts baseDataStore={baseDataStore} brespaDataStore={brespaDataStore}/>
                </div>

                <div className='col-md-8'>
                <div className='col-md-6'>
                    {baseDataStore.entries3.map(entry => {
                            z--;
                            var styles = {zIndex : z};
                            if (entry instanceof InputModel) {
                                return( <div className="form-group zup" key={entry.key} style={styles}>

                                    <InputComponent inputModel={entry} inputClasses={['size-input-height']}/>
                                </div>)
                            }else{
                                return (<div key={entry.key} className="form-group zup" style={styles}>
                                    <div className="input-group size-input-height" style={{width:'100%'}} >
                                        <div className="input-group-addon left-addon-dd" dangerouslySetInnerHTML={{__html: entry.title}}></div>
                                        <div className="input-group-btn ">
                                            <DropDown key={entry.key} dataProvider={entry} onSelect={entry.onSelect}/>
                                        </div>
                                    </div>
                                </div>)
                            }

                        }
                    ) }
                    {/*<div >
                        <img className="img-responsive" src={`${process.env.PUBLIC_URL}/images/${baseDataStore.strukturAuswahl.selectedOption.value.img}`}/>
                    </div>*/}

                </div>
                <div className='col-md-6'>
                    <div key={brespaDataStore.brespaselection.key} className="form-group zup" style={{zIndex : z}}>
                        <div className="input-group size-input-height" style={{width:'100%'}} >
                            <div className="input-group-addon left-addon-dd" dangerouslySetInnerHTML={{__html: brespaDataStore.brespaselection.title + ' ' + brespaDataStore.plattendicke.value + 'cm'}}>{}</div>
                            <div className="input-group-btn ">
                                <DropDown key={brespaDataStore.brespaselection.key} dataProvider={brespaDataStore.brespaselection} onSelect={brespaDataStore.brespaselection.onSelect}/>
                            </div>
                        </div>
                    </div>
                    {baseDataStore.entries4.map(entry => {
                            z--;
                            var styles = {zIndex : z};
                            if (entry instanceof InputModel) {
                                return( <div className="form-group zup" key={entry.key} style={styles}>

                                    <InputComponent inputModel={entry} inputClasses={['size-input-height']}/>
                                </div>)
                            }else{
                                return (<div key={entry.key} className="form-group zup" style={styles}>
                                    <div className="input-group size-input-height" style={{width:'100%'}} >
                                        <div className="input-group-addon left-addon-dd" dangerouslySetInnerHTML={{__html: entry.title}}></div>
                                        <div className="input-group-btn ">
                                            <DropDown key={entry.key} dataProvider={entry} onSelect={entry.onSelect}/>
                                        </div>
                                    </div>
                                </div>)
                            }

                        }
                    ) }
                </div>
                    <div className='col-md-12'>
                        <img className="img-responsive" src={`${process.env.PUBLIC_URL}/images/${baseDataStore.strukturAuswahl.selectedOption.value.img}`} style={{backgroundColor:"white"}}/>
                    </div>
                </div>
            </div>

        </div>;
    }

}

BaseDataEntry.propTypes = {
    baseDataStore: PropTypes.object.isRequired,
    brespaDataStore: PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./src/components/BaseDataEntry.js